import { render, staticRenderFns } from "./DataFieldEdit.vue?vue&type=template&id=cc237a9a&scoped=true&"
import script from "./DataFieldEdit.vue?vue&type=script&lang=js&"
export * from "./DataFieldEdit.vue?vue&type=script&lang=js&"
import style0 from "./DataFieldEdit.vue?vue&type=style&index=0&id=cc237a9a&prod&lang=scss&scoped=true&"
import style1 from "./DataFieldEdit.vue?vue&type=style&index=1&id=cc237a9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc237a9a",
  null
  
)

export default component.exports